angular.module('deal', ['core'])
    .factory('Deal', function ($resource) {
        return $resource('/crm/api/deal/:id', {}, {
            find: {method: 'GET', isArray: true},
            list: {method: 'GET', isArray: true},
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/deal/table'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        });
    })
    .factory('DealStatus', function ($resource) {
        return $resource('/crm/api/deal-status');
    })
    .service('DealLayoutSwitcher', function ($cookies) {
        let COOKIE_KEY = "deal-layout";
        this.getKeyValue = () => $cookies.getObject(COOKIE_KEY) || 'standard'
        this.getTemplate = () => {
            switch (this.getKeyValue()) {
                case 'standard':
                    return 'app/deal/list-standard.html';
                    break;
                case 'extended':
                    return 'app/deal/list-extended.html';
                    break;
                default:
            }
        }
        this.setTemplate = i => {
            $cookies.putObject(COOKIE_KEY, i);
        }
    })
    .service('DealService', function ($rootScope, $cookies, toastr, modals, Deal) {
        this.edit = id => {
            return Deal.get({id: id}).$promise.then(item => this.editModal(item));
        }
        this.editModal = entity => modals.open('app/deal/edit-modal.html', 'DealDialogController', entity, {size: "lg"}, "$ctrl");
        this.addModal = (params) => {
            let entity = {
                id: null,
                status: "PLANNING",
                contractStart: moment(),
                contractEnd: moment(),
                items: []
            };
            angular.extend(entity, params);
            return this.editModal(entity);
        };
        this.open = id => {
            return Deal.get({id: id}).$promise.then(item => this.showModal(item));
        }
        this.showModal = entity => modals.open('app/deal/show-modal.html', 'DealShowController', entity, {size: "lg"}, "$ctrl");
        this.remove = item => {
            return modals.confirmDelete("wybrany rekord", () => Deal.delete({id: item.id}, () => $rootScope.$broadcast('deal.updated')).$promise);
        };
    })
    .controller('DealShowController', function ($timeout, $scope, $rootScope, $filter, $uibModalInstance, data, toastr, Deal, DealService) {
        this.DealService = DealService;
        this.item = data;
        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        $scope.$on('deal.updated', () => this.cancel());
    })
    .controller('DealDialogController', function ($timeout, $scope, $rootScope, $filter, $uibModalInstance, data, toastr, DealStatus, Currency, Product, Deal, DealService) {
        this.DealService = DealService;
        this.item = data;

        DealStatus.query().$promise.then(items => this.statuses = items);
        Currency.query().$promise.then(items => {
            this.currencies = items;
            if (this.item.id === null) {
                this.item.currency = Currency.getDefault(items);
            }
        });

        this.refreshProducts = q => Product.autocomplete(q, 100).then(items => this.products = items);
        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let promise;
            if (this.item.id !== null) {
                promise = Deal.update(this.item).$promise;
            } else {
                promise = Deal.save(this.item).$promise;
            }
            return promise.then(result => {
                $rootScope.$broadcast('deal.updated');
                $uibModalInstance.close(result);
                toastr.success("Zapisano");
            })
        };

        this.setContractEnd1m = () => {
            this.item.contractEnd = moment(this.item.contractStart).add(1, 'M');
        };

        this.totalNet = () => {
            return this.item.items.map(item => Math.round((item.quantity || 0) * 100 * (item.ourPrice || 0)) / 100).reduce((prev, next) => prev + next, 0);
        };
        this.totalClientNet = () => {
            return this.item.items.map(item => Math.round((item.quantity || 0) * 100 * (item.clientSuggestedPrice || 0)) / 100).reduce((prev, next) => prev + next, 0);
        };
        this.totalWinnersNet = () => {
            return this.item.items.map(item => Math.round((item.quantity || 0) * 100 * (item.winnersPrice || 0)) / 100).reduce((prev, next) => prev + next, 0);
        };
        $scope.$on('deal.updated', () => this.cancel());
    })
    .component('dealList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/deal/list.html',
        controller: function ($scope, $state, $stateParams, DealLayoutSwitcher, Deal, DealService, DealStatus, Product, ProductGroup){
            this.DealService = DealService;
            this.reset = () => this.filters = {};
            this.$onInit = () => {
                this.viewType = DealLayoutSwitcher.getKeyValue();
                DealStatus.query().$promise.then(items => this.statuses = items);
            }
            this.getDealLayoutTemplate = () => DealLayoutSwitcher.getTemplate();
            this.setDealLayoutTemplate = value => {
                DealLayoutSwitcher.setTemplate(value);
                this.viewType = DealLayoutSwitcher.getKeyValue();
            };
            this.refreshGroups = q => ProductGroup.list({search: q}).$promise.then(items => this.groups = items);
            this.refreshProducts = q => Product.autocomplete(q, 100).then(items => this.products = items);

            $scope.$on('deal.updated', () => $state.reload());
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_DEALS",
            path: "/deal",
            ico: "fa fa-fw fa-dollar",
            name: 'deal.menu',
            order: 30
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('dealList', {
            parent: 'app',
            url: '/deal?{page:int}&{size:int}&sort&search&periodStart&periodEnd&client&status&product&productGroup',
            data: {
                authorities: ['ROLE_DEALS']
            },
            views: {
                'content@': "dealList"
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (Deal, $stateParams) => Deal.table(angular.copy($stateParams)).$promise
            }
        });
    });
